import styled from "styled-components";

const GoalCardWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  background-color: gray;
  padding: 20px 30px;
  height: 45px;
  text-align: left;
  background-color: #e5e5e5;
  border-radius: 8px;
  border-left: 8px solid #c4c4c4;

  .left {
    flex: 1;
    position: relative;
  }

  .right {
    flex: 1;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .launchedMessage {
    font-size: 16px;
    font-weight: 700;
    color: #6add98;
  }

  .deleteButton {
    color: #e26841;
    margin-right: 20px;
    cursor: pointer;
  }
`;

const BlankGoalCard = () => {
  return (
    <GoalCardWrapper>
      <div className="left">
        <span className="goalName"></span>
      </div>
      <div className="right"></div>
    </GoalCardWrapper>
  );
};

export default BlankGoalCard;
